// styles:
export { default as breakpoints } from "./breakpoints";
export { colors } from "./colors";
export {
    spacing,
    spacing2020WithoutBreakpoints,
    spacing2020HasBreakpoints
} from "./spacing";
export { default as fonts } from "./fonts";
export { regular, medium, bold, fontStyles } from "./fontStyles";
export { grid, containerMaxWidth } from "./widths";
export {
    easingSeconds,
    zIndexTop,
    desktopHeaderHeight,
    mobileHeaderHeight,
    boxShadow,
    scrollToDesktopWithHero,
    scrollToTabletWithHero,
    scrollToMobileWithHero,
    scrollToDesktopNoHero,
    scrollToMobileHeroSearchBar,
    scrollToTabletHeroSearchBar,
    scrollToDesktopHeroSearchBar,
    focusBorder,
    deviceTapColor
} from "./constants";

// components:
export { Avatar } from "./avatar";
export { AvatarPlaceholder } from "./avatarPlaceholder";
export { AvatarPlaceholderImg } from "./avatarPlaceholderImg";
export {
    Button,
    ButtonStyle,
    BlackButtonStyle,
    BlackButton,
    NewBlackButton,
    BlueButtonStyle,
    BlueButton,
    GrayButtonStyle,
    GrayButton,
    RoyalBlueButtonStyle,
    RoyalBlueButton,
    LightBlueButtonStyle,
    LightBlueButton,
    WhiteOutlineButtonStyle,
    WhiteOutlineButton
} from "./button";
export { default as ButtonGroup } from "./ButtonGroup";
export { Container } from "./container";
export { Checkbox } from "./checkbox";
export { Div } from "./div";
export { Grid, Row, Col } from "./grid";
export { Label } from "./label";
export { Loading } from "./loading";
export { MessageBanner } from "./messageBanner";
export { default as PageMeta } from "./PageMeta";
// InformationalMessageBanner extends MessageBanner
export { InformationalMessageBanner } from "./informationalMessageBanner";
export {
    Link,
    BaseText,
    HeaderSmall,
    textStyles,
    A,
    P,
    H1,
    H2,
    H3,
    ButtonLink
} from "./typography"; // use Headings below instead of these going forward

export { H1_2XL_New, H2New, H2_2XL_New, H4New, H5New, H6New } from "./headings"; // these are our new headings going forward (Aug 2020)

export {
    compensateForStickyHeader,
    fullWidthStyles,
    Layout,
    Section, // use SectionContainer instead
    SectionDark, // use SectionContainer instead
    SectionGray, // use SectionContainer instead
    SectionWhite, // use SectionContainer instead
    SiteContentWrapper,
    ContentShifterForStickyHeader
} from "./layout";

export { SectionContainer } from "./SectionContainer"; // new SectionContainer (Aug 2020)
export { SectionContainerJustText } from "./SectionContainerJustText"; // this is for SectionContainer sections that have headings

export { Flexbox } from "./flexbox";
export { FormInput } from "./FormInput";
export { FormFieldError } from "./formFieldError";
export { FormFieldErrorBorder } from "./formFieldErrorBorder";
export { Fieldset } from "./fieldset";
export { SaveButton } from "./saveButton";
export { SharePhotoToSocialMedia } from "./SharePhotoToSocialMedia";
export { TextInput } from "./textInput";
export { Thumbnail } from "./thumbnail";
export { TruncateText } from "./truncateText";
export { Tooltip } from "./tooltip";
export { RadioButton } from "./radioButton";
export { Icon } from "./icon";
export { LazyLoadImg } from "./lazyLoadImg";
export { Modal } from "./modal";
export {
    Card,
    CardTitle,
    CardDescription,
    CardCta,
    CardBulletList,
    CardBulletListTitle,
    CardBulletListTitleIcon,
    CardBulletListTitleContainer,
    CardHighlight,
    CardHighlightsContainer,
    CardIconContainer,
    CardMobileContentContainer,
    CardNonMobileContentContainer
} from "./card";

// To be used with Material UI grid:
export { gridThemeStyles, MaterialUIGridContainer } from "./materialUI";

// marketing page
export {
    MarketingPageSectionHeadingContainer,
    MarketingPageSectionEyebrowSubheading,
    MarketingPageSectionHeading,
    MarketingPageSectionBiLine
} from "./marketingPageSectionHeading";

export {
    Table,
    TableRow,
    TableBody,
    TableData,
    TableSubheading,
    TableColumnHeading,
    TableRowHeading,
    TableHead,
    TableColumnHighlight
} from "./table";

export {
    FeatureTableMobileColumnHeading,
    FeatureTableMobileBullet,
    FeatureTableMobileList
} from "./featureTableMobile";

/* TODO:
- need to organize styles vs shared components

- organize exports by type - all form elements together, all buttons together, etc
*/
